import Dexie from 'dexie';

const dbName = 'editorAC';
const dbVersion = 7;
const tmpSavedTemplate = 'temp_saved_template';

let db = null;
try {
  db = new Dexie(dbName);
  db.version(dbVersion).stores({
    template:
      '&id, json, fonts, thumbnail, created_at, update_at, userId, numberActions, designName',
    page: '&id, json, fonts, thumbnail, type, created_at, update_at',
    modifiedPages:
      '&id, pageId, type, srcPageIndex, minDeletedPageIndex, created_at, update_at',
    fileImage: '&id, data',
  });
} catch (error) {
  console.log(error);
  db = null;
}

const saveTemplate = (template) => {
  if (!db) return;
  console.log('---> SAVE TEMPLATE ---', template);
  try {
    const templateId = template.id || tmpSavedTemplate;
    const existedTemplate = db.template.get(templateId);
    if (!existedTemplate) {
      return db.template.add({
        id: templateId,
        json: template.json,
        fonts: template.fonts,
        thumbnail: template.thumbnail,
        created_at: template.created_at || Date.now(),
        update_at: template.update_at || Date.now(),
        userId: template.userId,
        numberActions: 0,
        designName: 'No name',
      });
    } else {
      return db.template.update(templateId, {
        json: template.json,
        fonts: template.fonts,
        thumbnail: template.thumbnail,
        update_at: Date.now(),
        userId: template.userId,
        numberActions: template.numberActions,
        designName: template.designName,
      });
    }
  } catch (e) {
    return null;
  }
};

const savePage = (page) => {
  if (!db) return;
  console.log('---> SAVE PAGE ---', page);
  try {
    return db.page.add({
      id: page.id,
      json: page.json,
      fonts: page.fonts,
      thumbnail: page.thumbnail,
      type: page.type,
      created_at: page.created_at || Date.now(),
      update_at: page.update_at || Date.now(),
    });
  } catch (e) {
    return null;
  }
};

const saveMultiplePages = (pages) => {
  if (!db) return;
  console.log('saveMultiplePagessssss', JSON.stringify(pages));
  try {
    return db.page.bulkAdd(
      pages.map((page) => ({
        id: page.id,
        pageId: page.pageId,
        pageIndex: page.pageIndex,
        json: page.json,
        fonts: page.fonts,
        thumbnail: page.thumbnail,
        type: page.type,
        created_at: page.created_at || Date.now(),
        update_at: page.update_at || Date.now(),
      })),
    );
  } catch (e) {
    return null;
  }
};

const saveModifiedPage = (modifiedPage) => {
  if (!db) return;
  try {
    return db.modifiedPages.add({
      id: modifiedPage.id,
      pageId: modifiedPage.pageId,
      type: modifiedPage.type,
      srcPageIndex: modifiedPage.srcPageIndex,
      minDeletedPageIndex: modifiedPage.minDeletedPageIndex,
    });
  } catch (e) {
    return null;
  }
};

const updateTemplate = (updatedData, id = tmpSavedTemplate) => {
  if (!db) return;
  try {
    return db.template.update(id, {
      json: updatedData.json,
      fonts: updatedData.fonts,
      thumbnail: updatedData.thumbnail,
      update_at: Date.now(),
      userId: updatedData.userId,
      numberActions: updatedData.numberActions,
      designName: updatedData.designName,
    });
  } catch (e) {
    return null;
  }
};

const updateNumberActionsDB = (numberActions, id = tmpSavedTemplate) => {
  if (!db) return;
  try {
    return db.template.update(id, {
      update_at: Date.now(),
      numberActions,
    });
  } catch (e) {
    return null;
  }
};

const updateDesignNameDB = (designName, id = tmpSavedTemplate) => {
  if (!db) return;
  try {
    return db.template.update(id, {
      update_at: Date.now(),
      designName,
    });
  } catch (e) {
    return null;
  }
};

const getTemplate = (id = tmpSavedTemplate) => {
  if (!db) return;
  try {
    return db.template.get(id);
  } catch (e) {
    return null;
  }
};

const getPage = (id) => {
  if (!db) return;
  try {
    return db.page.get(id);
  } catch (e) {
    return null;
  }
};

const getAllPages = async () => {
  if (!db) return;
  try {
    const allPages = await db.page.toArray();
    console.log('getAllPages ', allPages);
    return allPages.toSorted((a, b) => a.pageIndex - b.pageIndex);
  } catch (e) {
    return [];
  }
};

const getAllModifiedPagesInfo = () => {
  if (!db) return;
  try {
    return db.modifiedPages.toArray();
  } catch (e) {
    return [];
  }
};

const getTemplateByUserId = async (userId) => {
  if (!db) return;
  try {
    return await db.template.where({ userId }).first((rs) => rs);
  } catch (error) {
    return null;
  }
};

const deleteTemplate = (id = tmpSavedTemplate) => {
  if (!db) return;
  console.log('--- DELETE TEMPLATE ---');
  console.log(`id: ${id}`);
  try {
    return db.template.delete(id);
  } catch (e) {
    return null;
  }
};

const deleteAllPages = () => {
  if (!db) return;
  try {
    return db.page.clear();
  } catch (e) {
    return null;
  }
};

const deleteModifiedPagesInfo = () => {
  if (!db) return;
  try {
    return db.modifiedPages.clear();
  } catch (e) {
    return null;
  }
};

const saveFileImage = (data) => {
  console.log('---> SAVE FILE IMAGE ---');
  try {
    return db.fileImage.add({
      id: '1',
      data,
    });
  } catch (e) {
    return null;
  }
};

const deleteFileImage = () => {
  try {
    return db.fileImage.clear();
  } catch (e) {
    return null;
  }
};

const getFileImage = () => {
  try {
    return db.fileImage.get('1');
  } catch (e) {
    return null;
  }
};

export {
  saveTemplate,
  updateTemplate,
  getTemplate,
  deleteTemplate,
  getTemplateByUserId,
  updateNumberActionsDB,
  updateDesignNameDB,
  savePage,
  saveMultiplePages,
  getPage,
  getAllPages,
  deleteAllPages,
  saveModifiedPage,
  getAllModifiedPagesInfo,
  deleteModifiedPagesInfo,
  saveFileImage,
  deleteFileImage,
  getFileImage,
};
